import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchShowcase } from 'Catalog/Showcase/ducks'
import MediaQuery from 'react-responsive'

import Tagging from 'Catalog/Product/ProductCard/Tagging'

import { ProductCardContainer } from 'Catalog/Product/ProductCard'
import Showcase from './Showcase'

class ShowcaseContainer extends Component {
  constructor (props) {
    super(props)

    this.handleLoadShowcase = this.handleLoadShowcase.bind(this)
  }

  handleLoadShowcase () {
    const { loadShowcase, showcaseType, identifier } = this.props
    loadShowcase(showcaseType, identifier)
  }

  componentDidMount () {
    this.handleLoadShowcase()
  }

  componentDidUpdate (prevProps) {
    if (prevProps.onlyCash !== this.props.onlyCash) {
      this.handleLoadShowcase()
    }
  }

  render () {
    const { loadShowcase: _, products, ...props } = this.props

    return (
      <Showcase products={products} {...props}>
        <Tagging type='send' />
        <MediaQuery minDeviceWidth={426}>
          {products.map((sku, index) => (
            <ProductCardContainer position={index} identifier={this.props.identifier} titleShowcase={props.title} key={sku} sku={sku} />
          ))}
        </MediaQuery>
        <MediaQuery maxDeviceWidth={425}>
          {products.slice(0, 4).map((sku, index) => (
            <ProductCardContainer
              isResponsiveEnabled
              identifier={this.props.identifier}
              titleShowcase={props.title}
              position={index}
              className='col-12 mb-1 px-half d-block card-mobile'
              sku={sku}
              key={sku + '_mobile'}
            />
          ))}
        </MediaQuery>
      </Showcase>
    )
  }
}

ShowcaseContainer.propTypes = {
  loadShowcase: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showcaseType: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  products: PropTypes.array,
  onlyCash: PropTypes.bool
}

ShowcaseContainer.defaultProps = {
  isLoading: true,
  products: []
}

const mapStateToProps = (
  { showcases, onlyCash },
  { showcaseType, identifier }
) => {
  const showcase = showcases[showcaseType]
    ? showcases[showcaseType][identifier]
    : {}

  return { ...showcase, onlyCash }
}

const mapDispatchToProps = dispatch => ({
  loadShowcase: (showcaseType, identifier) =>
    dispatch(fetchShowcase(showcaseType, identifier))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowcaseContainer)



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/ShowcaseContainer.js